import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./store/auth-context";
import { FilterContextProvider } from "./store/filter-context";
import { DemandesContextProvider } from "./store/demandes-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <DemandesContextProvider>
      <FilterContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FilterContextProvider>
    </DemandesContextProvider>
  </AuthContextProvider>
);
